import {
  PA_ALLOWED_PATHS,
  PA_NOT_SHOW_BOTTOM_MENU_PATHS,
} from '../../modules/PlanoAdaptativo/components/PlanConfig/MainCard';

export const isPlanoAdaptativo = () => {
  const path = location.pathname;
  const alloweds = [...PA_ALLOWED_PATHS, ...PA_NOT_SHOW_BOTTOM_MENU_PATHS].some(
    (pattern) => {
      const regex = new RegExp(pattern.replace('UUID', '[^/]+'));
      return regex.test(path);
    }
  );

  return alloweds;
};

export const isMenuPlanoAdaptativo = () => {
  const path = location.pathname;
  const alloweds = PA_ALLOWED_PATHS.some((pattern) => {
    const regex = new RegExp(pattern.replace('UUID', '[^/]+'));
    return regex.test(path);
  });

  const notAlloweds = PA_NOT_SHOW_BOTTOM_MENU_PATHS.some((pattern) => {
    const regex = new RegExp(pattern.replace('UUID', '[^/]+'));
    return regex.test(path);
  });

  return alloweds && !notAlloweds;
};

export const isMenuPlanoAdaptativoNotShowBottomMenu = () => {
  const path = location.pathname;
  const notAlloweds = PA_NOT_SHOW_BOTTOM_MENU_PATHS.some((pattern) => {
    const regex = new RegExp(pattern.replace('UUID', '[^/]+'));
    return regex.test(path);
  });

  return notAlloweds;
};
